// AgendaViewDay.jsx

import React from 'react';

// CSS
import './AgendaViewDay.css';

// Components
import {
  formatAgendaDayLabel,
  formatAgendaMonthLabel,
} from '../agendaFormatters';
import AgendaViewEvent from '../event/AgendaViewEvent';

/**
 * AgendaViewDay
 * 
 * Renders a single day in the agenda view.
 * 
 * @param {Object} group - The group of events for the day, containing the date and items.
 * @param {string} language - The language code for formatting dates and times.
 * @param {function} onNodeClick - Callback function to handle clicks on event nodes.
 *  
 *
 * @returns {ReactNode} - AgendaViewDay.
 */
const AgendaViewDay = ({ group, language, compact, onNodeClick, onNodeDoubleClick }) => {

  // ----- RENDER ----- //

  return (

    <div
      className="agenda-view-day-container"
      style={{
        gridTemplateColumns: compact ? '56px 1fr' : '76px 1fr',
      }}
    >

      {/* DATE */}
      <div className="agenda-view-day-date">

        {/* DAY */}
        <div
          className="agenda-view-day-date-day"
        >
          {formatAgendaDayLabel(group.date, language)}
        </div>

        {/* DATE NUMBER */}
        <div
          className="agenda-view-day-date-number"
        >
          {group.date.getDate()}
        </div>

        {/* MONTH */}
        <div
          className="agenda-view-day-date-month"
        >
          {formatAgendaMonthLabel(group.date, language)}
        </div>

      </div>

      {/* EVENTS */}
      <div className="agenda-view-day-events-wrapper">

        {group.items.map((item, index) => (
          <>
            <AgendaViewEvent
              key={`${item.node?.key || 'node'}-${item.field?.name || 'date'}-${index}`}
              item={item}
              language={language}
              onNodeClick={onNodeClick}
              onNodeDoubleClick={onNodeDoubleClick}
            />
          </>
        ))}

      </div>
    </div>

  );
};

// Dev Tools
AgendaViewDay.displayName = 'AgendaViewDay';

export default AgendaViewDay;
